import React from "react";
import { statusCategories } from "../../../../Findings/FindingDetailsPane/FindingDetailsPaneHeader/Statuses/StatusUtils";
import PieChart from "../../PieChart";
import { SLA } from "../SLAUtils";
import type { SelectedScope } from "../../../../types/scope";

interface ComplianceProps {
  selectedScope?: SelectedScope | null;
  filterToExecute?: string | null;
  scopeToExecute?: string | null;
  id?: string | number;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const Compliance: React.FC<ComplianceProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  setIsReadyToExport,
}) => {
  const filtersConfig = {
    filtersjson: filterToExecute || null,
    scopesjson: scopeToExecute || null,
    scopesid: selectedScope?.value?.id,
  };

  const chartFilterValue = [
    {
      type: "category",
      key: statusCategories.OPEN,
      id: statusCategories.OPEN,
    },
  ];

  const skip =
    (!scopeToExecute && !selectedScope?.value?.id) || !filterToExecute;

  const chartName = `slaComplianceDiv-${id}`;
  return (
    <PieChart
      categories={SLA}
      skip={skip}
      groupBy={["finding.sla_status"]}
      filtersConfig={filtersConfig}
      legendTitle={"SLA Status"}
      chartName={chartName}
      chartFilterValue={chartFilterValue}
      actualFilterField={"remediation_item.sla_status"}
      dataSubject={"Findings"}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default Compliance;
